function initializeReviewsSwiper() {
  var swiper = new Swiper(".reviews-umySwiper", {
    spaceBetween: 20,
    loop: true,
    slidesPerView: 4,
    speed: 1000,
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      348: {
        centeredSlides: true,
        slidesPerView: 1,
        spaceBetween: 20,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20,
      }
    }
  });
}
// Call the function
initializeReviewsSwiper();

function initMCSSlider() {
  const sliderEl = document.querySelector('.M-mcs-Swiper');

  if (!sliderEl) return;

  // Prevent duplicate initialization
  if (sliderEl.swiper) {
    sliderEl.swiper.destroy(true, true);
  }

  sliderEl.classList.remove('preview');

  const swiper = new Swiper('.M-mcs-Swiper', {
    speed: 300,
    loop: true,
    centeredSlides: true,

    navigation: {
      nextEl: '.m-mcs-next',
      prevEl: '.m-mcs-prev',
    },

    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    breakpoints: {
      320: {
        slidesPerView: 1.5,
        spaceBetween: 15,
      },

      750: {
        slidesPerView: 3,
        spaceBetween: 20,
      },

      950: {
        slidesPerView: 4,
        spaceBetween: 20,
      }
    }
  });

  // Example slide change event
  swiper.on('slideChange', function () {
    console.log('Active slide:', swiper.realIndex);
  });
}

// Initial load
document.addEventListener('DOMContentLoaded', initMCSSlider);

// Shopify Theme Editor support
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initMCSSlider);
  document.addEventListener('shopify:section:unload', function () {
    const sliderEl = document.querySelector('.M-mcs-Swiper');

    if (sliderEl && sliderEl.swiper) {
      sliderEl.swiper.destroy(true, true);
    }
  });
}

function initUISSlider() {
  var swiper = new Swiper(".UISSlider", {
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    slidesPerView: 1.7,
    spaceBetween: 10,

    breakpoints: {
      0: {
        slidesPerView: 1.7,
        spaceBetween: 10,
      },
      769: {
        slidesPerView: 2.8,
        spaceBetween: 10,
      },
    },
  });
}

document.addEventListener('click', function(e) {
  const button = e.target.closest('.u-collapsible-toggle');
  if (!button) return;
  const item = button.closest('.u-collapsible-item');
  const content = item.querySelector('.u-collapsible-content');
  const isAlreadyActive = item.classList.contains('active');
  const allActiveItems = document.querySelectorAll('.u-collapsible-item.active');
  allActiveItems.forEach(activeItem => {
    activeItem.classList.remove('active');
    const activeContent = activeItem.querySelector('.u-collapsible-content');
    if (activeContent) {
      activeContent.style.maxHeight = null;
    }
  });
  if (!isAlreadyActive) {
    item.classList.add('active');
    content.style.maxHeight = content.scrollHeight + 'px';
  }
});


// M addon Gift
(function () {
  if (window.__uGiftAddonInit) return;
  window.__uGiftAddonInit = true;

  var ADD_URL = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('product-single__form')) return;

    // Only PDP / quick-view scope. Collection grid cards have no .product-section parent.
    var scope = form.closest('.product-section');
    if (!scope) return;

    var card = scope.querySelector('[data-u-addon-card]');
    var checkbox = scope.querySelector('[data-u-addon-checkbox]');
    if (!card || !checkbox || !checkbox.checked || checkbox.disabled) return;

    var addonId = card.dataset.addonVariantId;
    if (!addonId) {
      console.warn('[u-gift-addon] Missing addon variant id.');
      return;
    }

    // Take over from theme.AjaxProduct
    e.preventDefault();
    e.stopImmediatePropagation();

    var btn = form.querySelector('[data-add-to-cart]');
    if (btn) btn.classList.add('btn--loading');

    // Build the main line item from the real form data
    var fd = new FormData(form);
    var mainItem = {
      id: parseInt(fd.get('id'), 10),
      quantity: parseInt(fd.get('quantity') || 1, 10)
    };

    var props = {};
    fd.forEach(function (value, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m && value) props[m[1]] = value;
    });
    if (Object.keys(props).length) mainItem.properties = props;

    fetch(ADD_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [mainItem, { id: parseInt(addonId, 10), quantity: 1 }]
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (btn) btn.classList.remove('btn--loading');

        if (data.status === 422 || data.status === 404) {
          var old = form.querySelector('.errors');
          if (old) old.remove();
          var err = document.createElement('div');
          err.className = 'errors text-center';
          err.textContent = data.description || data.message;
          form.append(err);
          return;
        }

        // This is what opens + rebuilds this theme's cart drawer
        form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: { product: data, addToCartBtn: btn }
        }));

        if (theme.settings.cartType === 'page') {
          window.location = theme.routes.cartPage;
        }
      })
      .catch(function (err) {
        if (btn) btn.classList.remove('btn--loading');
        console.error('[u-gift-addon] add failed:', err);
      });
  }, true); // <-- capture:true is essential

  // Keep clicks on the checkbox from triggering the card link
  document.addEventListener('click', function (e) {
    if (e.target.matches && e.target.matches('[data-u-addon-checkbox]')) {
      e.stopPropagation();
    }
  });
})();


// Shipping Protection toggle sync
function initializeReviewsSwiper() {
  var swiper = new Swiper(".reviews-umySwiper", {
    spaceBetween: 20,
    loop: true,
    slidesPerView: 4,
    speed: 1000,
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      348: {
        centeredSlides: true,
        slidesPerView: 1,
        spaceBetween: 20,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20,
      }
    }
  });
}
// Call the function
initializeReviewsSwiper();

function initMCSSlider() {
  const sliderEl = document.querySelector('.M-mcs-Swiper');

  if (!sliderEl) return;

  // Prevent duplicate initialization
  if (sliderEl.swiper) {
    sliderEl.swiper.destroy(true, true);
  }

  sliderEl.classList.remove('preview');

  const swiper = new Swiper('.M-mcs-Swiper', {
    speed: 300,
    loop: true,
    centeredSlides: true,

    navigation: {
      nextEl: '.m-mcs-next',
      prevEl: '.m-mcs-prev',
    },

    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    breakpoints: {
      320: {
        slidesPerView: 1.5,
        spaceBetween: 15,
      },

      750: {
        slidesPerView: 3,
        spaceBetween: 20,
      },

      950: {
        slidesPerView: 4,
        spaceBetween: 20,
      }
    }
  });

  // Example slide change event
  swiper.on('slideChange', function () {
    console.log('Active slide:', swiper.realIndex);
  });
}

// Initial load
document.addEventListener('DOMContentLoaded', initMCSSlider);

// Shopify Theme Editor support
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initMCSSlider);
  document.addEventListener('shopify:section:unload', function () {
    const sliderEl = document.querySelector('.M-mcs-Swiper');

    if (sliderEl && sliderEl.swiper) {
      sliderEl.swiper.destroy(true, true);
    }
  });
}

function initUISSlider() {
  var swiper = new Swiper(".UISSlider", {
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    slidesPerView: 1.7,
    spaceBetween: 10,

    breakpoints: {
      0: {
        slidesPerView: 1.7,
        spaceBetween: 10,
      },
      769: {
        slidesPerView: 2.8,
        spaceBetween: 10,
      },
    },
  });
}

// document.addEventListener('click', function(e) {
//   const button = e.target.closest('.u-collapsible-toggle');
//   if (!button) return;
//   const item = button.closest('.u-collapsible-item');
//   const content = item.querySelector('.u-collapsible-content');
//   const isAlreadyActive = item.classList.contains('active');
//   const allActiveItems = document.querySelectorAll('.u-collapsible-item.active');
//   allActiveItems.forEach(activeItem => {
//     activeItem.classList.remove('active');
//     const activeContent = activeItem.querySelector('.u-collapsible-content');
//     if (activeContent) {
//       activeContent.style.maxHeight = null;
//     }
//   });
//   if (!isAlreadyActive) {
//     item.classList.add('active');
//     content.style.maxHeight = content.scrollHeight + 'px';
//   }
// });


// M addon Gift
(function () {
  if (window.__uGiftAddonInit) return;
  window.__uGiftAddonInit = true;

  var ADD_URL = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('product-single__form')) return;

    // Only PDP / quick-view scope. Collection grid cards have no .product-section parent.
    var scope = form.closest('.product-section');
    if (!scope) return;

    var card = scope.querySelector('[data-u-addon-card]');
    var checkbox = scope.querySelector('[data-u-addon-checkbox]');
    if (!card || !checkbox || !checkbox.checked || checkbox.disabled) return;

    var addonId = card.dataset.addonVariantId;
    if (!addonId) {
      console.warn('[u-gift-addon] Missing addon variant id.');
      return;
    }

    // Take over from theme.AjaxProduct
    e.preventDefault();
    e.stopImmediatePropagation();

    var btn = form.querySelector('[data-add-to-cart]');
    if (btn) btn.classList.add('btn--loading');

    // Build the main line item from the real form data
    var fd = new FormData(form);
    var mainItem = {
      id: parseInt(fd.get('id'), 10),
      quantity: parseInt(fd.get('quantity') || 1, 10)
    };

    var props = {};
    fd.forEach(function (value, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m && value) props[m[1]] = value;
    });
    if (Object.keys(props).length) mainItem.properties = props;

    fetch(ADD_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [mainItem, { id: parseInt(addonId, 10), quantity: 1 }]
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (btn) btn.classList.remove('btn--loading');

        if (data.status === 422 || data.status === 404) {
          var old = form.querySelector('.errors');
          if (old) old.remove();
          var err = document.createElement('div');
          err.className = 'errors text-center';
          err.textContent = data.description || data.message;
          form.append(err);
          return;
        }

        // This is what opens + rebuilds this theme's cart drawer
        form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: { product: data, addToCartBtn: btn }
        }));

        if (theme.settings.cartType === 'page') {
          window.location = theme.routes.cartPage;
        }
      })
      .catch(function (err) {
        if (btn) btn.classList.remove('btn--loading');
        console.error('[u-gift-addon] add failed:', err);
      });
  }, true); // <-- capture:true is essential

  // Keep clicks on the checkbox from triggering the card link
  document.addEventListener('click', function (e) {
    if (e.target.matches && e.target.matches('[data-u-addon-checkbox]')) {
      e.stopPropagation();
    }
  });
})();


// Shipping Protection toggle sync
(function () {
  var spBusy = false;
  var CART_UPDATE_URL = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/update.js';

  function spToggleEl() {
    return document.querySelector('[data-sp-toggle]');
  }

  function spSync() {
    if (spBusy) return;
    var toggle = spToggleEl();
    if (!toggle) return;

    theme.cart.getCart().then(function (cart) {
      var vid = parseInt(toggle.dataset.variantId, 10);
      var inCart = false;
      var normalItems = 0;

      cart.items.forEach(function (item) {
        if (item.variant_id === vid) {
          inCart = true;
        } else {
          normalItems += item.quantity;
        }
      });

      toggle.checked = inCart;

      var rejected = cart.attributes && cart.attributes.sp_rejected === 'true';

      if (normalItems > 0 && !inCart && !rejected) {
        spUpdate(vid, 1, {});
      } else if (normalItems === 0 && inCart) {
        spUpdate(vid, 0, {});
      }
    }).catch(function (err) {
      console.error('[shipping-protection] getCart failed:', err);
    });
  }

  function spUpdate(vid, qty, attributes) {
    spBusy = true;
    var updates = {};
    updates[vid] = qty;

    fetch(CART_UPDATE_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates, attributes: attributes })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/update.js returned ' + r.status);
        return r.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(function (err) {
        console.error('[shipping-protection] update failed:', err);
      })
      .finally(function () {
        setTimeout(function () { spBusy = false; }, 400);
      });
  }

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.matches('[data-sp-toggle]')) return;
    var vid = parseInt(e.target.dataset.variantId, 10);
    var checked = e.target.checked;
    spUpdate(vid, checked ? 1 : 0, { sp_rejected: checked ? 'false' : 'true' });
  });

  document.addEventListener('cart:updated', spSync);
  document.addEventListener('cart:build', function () { setTimeout(spSync, 300); });
  document.addEventListener('ajaxProduct:added', function () { setTimeout(spSync, 300); });
  document.addEventListener('DOMContentLoaded', spSync);
  spSync();
})();
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-cart-remove]');
  if (!btn) return;

  e.preventDefault();

  var key = btn.dataset.key;
  if (!key) return;

  var form = btn.closest('form[data-location]');
  if (!form) return;

  btn.classList.add('is-loading');

  theme.cart.changeItem(key, 0).then(function (cart) {
    var parsedCart = JSON.parse(cart);

    if (parsedCart.status === 422) {
      alert(parsedCart.message);
      btn.classList.remove('is-loading');
      return;
    }

    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { cart: parsedCart }
    }));
  }).catch(function () {
    btn.classList.remove('is-loading');
  });
});